module.exports = __webpack_public_path__ + "static/media/moth-product-poster.e213ad4f.png";